import { DatePicker, Divider, Input, Radio, Slider } from "antd";
import React from "react";

import calendar from "../../../assets/icons/calendar.png";
import dayjs from "dayjs";

export default function AudienceIdentificationFilter({ identificationFilter, setIdentificationFilter }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 30 }}>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {/* First-nama nad Last-name filter */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly", marginBottom: 30 }}>
          <div style={{ width: "100%" }}>
            <p style={{ marginBottom: 20, fontSize: 18 }}>Patient's First Name</p>
            <Input
              name="first_name"
              value={identificationFilter.first_name}
              placeholder="Enter First Name"
              style={{ borderRadius: 7, border: "1px solid #6B43B5" }}
              onChange={(e) => setIdentificationFilter((prev) => ({ ...prev, first_name: e.target.value }))}
            />
          </div>

          <Divider type="vertical" style={{ height: 70, backgroundColor: "#B7B7B7", marginInline: 20 }} />

          <div style={{ width: "100%" }}>
            <p style={{ marginBottom: 20, fontSize: 18 }}>Patient's Last Name</p>

            <Input
              name="last_name"
              value={identificationFilter.last_name}
              placeholder="Enter Last Name"
              style={{ borderRadius: 7, border: "1px solid #6B43B5" }}
              onChange={(e) => setIdentificationFilter((prev) => ({ ...prev, last_name: e.target.value }))}
            />
          </div>
        </div>

        {/* Gender and Age filter */}
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-evenly", marginBottom: 30 }}>
          <div style={{ width: "100%" }}>
            <p style={{ marginBottom: 20, fontSize: 18 }}>Gender</p>

            <Radio.Group
              value={identificationFilter.gender}
              style={{ display: "flex" }}
              onChange={(e) => setIdentificationFilter((prev) => ({ ...prev, gender: e.target.value }))}
              options={[
                { value: "male", className: "gender-radio", label: "Male" },
                { value: "female", className: "gender-radio", label: "Female" },
              ]}
            />
          </div>

          <Divider type="vertical" style={{ height: 70, backgroundColor: "#B7B7B7", marginInline: 20 }} />

          <div style={{ width: "100%" }}>
            <p style={{ marginBottom: 20, fontSize: 18 }}>Age</p>

            <Slider
              range
              defaultValue={[0, 17]}
              min={0}
              max={100}
              onChange={(value) => setIdentificationFilter((prev) => ({ ...prev, age: value }))}
            />
          </div>
        </div>

        <p style={{ fontSize: 14, color: "#B7B7B7", marginBottom: 10 }}>
          If you just select start date the result will be afterwards and if select end date the result would be before.
        </p>

        {/* Date joined range */}
        <div>
          <p style={{ marginBottom: 20, fontSize: 18 }}>Date Joined Range</p>

          <div style={{ display: "flex", alignItems: "center", gap: 10, width: "100%", marginBottom: 30 }}>
            <IdentificationDatePickerWithLabel
              dataName="joined_date_start"
              placeholder="Select Start Date"
              dateHandler={(date, dateString) =>
                setIdentificationFilter((prevDates) => ({ ...prevDates, joined_date: { ...prevDates.joined_date, lower: dateString } }))
              }
              label="From"
              value={identificationFilter.joined_date.lower}
            />
            <IdentificationDatePickerWithLabel
              dataName="joined_date_end"
              placeholder="Select End Date"
              dateHandler={(date, dateString) =>
                setIdentificationFilter((prevDates) => ({ ...prevDates, joined_date: { ...prevDates.joined_date, upper: dateString } }))
              }
              value={identificationFilter.joined_date.upper}
              label="To"
            />
          </div>
        </div>

        {/* Birth date range */}
        <div>
          <p style={{ marginBottom: 20, fontSize: 18 }}>Birht Date Range</p>

          <div style={{ display: "flex", alignItems: "center", gap: 10, width: "100%" }}>
            <IdentificationDatePickerWithLabel
              dataName="birth_date_start"
              placeholder="Select start Date"
              dateHandler={(date, dateString) =>
                setIdentificationFilter((prevDates) => ({ ...prevDates, birth_date: { ...prevDates.birth_date, lower: dateString } }))
              }
              value={identificationFilter.birth_date.lower}
              label="From"
            />
            <IdentificationDatePickerWithLabel
              dataName="birth_date_end"
              placeholder="Select End Date"
              dateHandler={(date, dateString) =>
                setIdentificationFilter((prevDates) => ({ ...prevDates, birth_date: { ...prevDates.birth_date, upper: dateString } }))
              }
              value={identificationFilter.birth_date.upper}
              label="To"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function IdentificationDatePickerWithLabel({ dataName, value, placeholder, dateHandler, label }) {
  return (
    <>
      <p style={{ marginBottom: 0, fontSize: 16, color: "#B7B7B7" }}>{label}</p>

      <DatePicker
        suffixIcon={<img src={calendar} alt="calendar" />}
        name={dataName}
        placeholder={placeholder}
        value={value ? dayjs(value, "YYYY-MM-DD") : null}
        format="YYYY-MM-DD"
        dateFormat="YYYY-MM-DD"
        style={{ width: "100%", borderRadius: 10, border: "1px solid #6B43B5", padding: "10px 20px" }}
        onChange={(_, dateString) => dateHandler(dataName, dateString)}
      />
    </>
  );
}
